var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFoodPlots = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M16.737 14.62c.274-3.604 1.45-7.079 3.416-10.097.113-.174.1-.402-.033-.562-.132-.159-.352-.211-.541-.129-2.212 1.121-4.198 2.65-5.855 4.507-.02.064-.08.108-.148.108-.067 0-.126-.044-.147-.108-.625-2.83-1.639-5.557-3.013-8.102-.106-.188-.326-.278-.532-.219-.206.06-.345.253-.337.47-.08 3.432-.54 6.845-1.367 10.175-.024.063-.077.11-.142.127-.066.015-.135-.003-.184-.049-1.594-1.983-3.598-3.591-5.87-4.71-.19-.083-.41-.03-.542.129-.133.159-.146.387-.033.561 1.69 2.625 2.72 5.627 2.997 8.746.03.085-.01.179-.09.216-.082.037-.177.005-.22-.074C3.099 14.506 1.96 13.545.71 12.75c-.18-.13-.427-.107-.582.054-.155.16-.171.41-.039.59 1.265 2.382 2.265 4.9 2.982 7.505H18.6c.668-3.03 1.712-5.963 3.105-8.73.189-.187.192-.492.008-.683-.184-.19-.487-.194-.676-.008-1.49.885-2.836 1.997-3.99 3.297-.058.052-.14.064-.209.03-.069-.036-.11-.11-.102-.187z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFoodPlots, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/food-plots.c73d83f5.svg";
export { ForwardRef as ReactComponent };